class Hed {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const hnBtn = document.querySelector('.hn-btn');
    const lHeader = document.querySelector('.l-header');
    const body = document.body;
    
    if (hnBtn && lHeader) {
      hnBtn.addEventListener('click', () => {
        lHeader.classList.toggle('is-active');
        body.classList.toggle('is-fixed');
      });
    }

    $('.inhn-btn').click(function(){
      $('.interview-header').toggleClass('is-active');
      $('body').toggleClass('is-fixed');
    });

    $('.mega-link').click(function(){
      $('.interview-header').removeClass('is-active');
      $('body').removeClass('is-fixed');
    });
  }
}